import React from 'react';
import { TextField, ReferenceField } from 'react-admin';
import { styled } from '@mui/system';

const ReplacedStyle = styled('span')({
  color: 'lightgrey',
  textDecoration: 'line-through',
});

const IncludedStyle = styled('span')({
  color: '#3f51b5',
});

const ModuleField = ({ replacedIds, source, record = {} }) => (
  !replacedIds ? (
    <TextField component={IncludedStyle} source={source} record={record} />
  ) : (
    record && (replacedIds.indexOf(record.id) === -1 && replacedIds.indexOf(record.moduleId) === -1) ? (
      <TextField component={IncludedStyle} source={source} record={record} />
    ) : (
      <TextField component={ReplacedStyle} source={source} record={record} />
    )
  )
);

export default ModuleField;

const ModuleReferenceField = ({ replacedIds, reference, source, referencedSource, record = {}, ...props }) => (
  !replacedIds ? (
    <ReferenceField source={source} reference={reference} record={record} {...props}>
      <TextField component={IncludedStyle} source={referencedSource} />
    </ReferenceField>
  ) : (
    record && (replacedIds.indexOf(record.id) === -1 && replacedIds.indexOf(record.moduleId) === -1) ? (
      <ReferenceField source={source} reference={reference} record={record} {...props}>
        <TextField component={IncludedStyle} source={referencedSource} />
      </ReferenceField>
    ) : (
      <ReferenceField source={source} reference={reference} record={record} {...props}>
        <TextField component={ReplacedStyle} source={referencedSource} />
      </ReferenceField>
    )
  )
);

export { ModuleReferenceField };
